import Vue from 'vue'
import Vuex from 'vuex'
import {db,auth,increment, decrement,firebaseTimeNow} from '../firebase'
import router from '../router/index'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    profile: {},
    units: [],
    forces: [],
    errors: [],
    current: {},
  },
  mutations: {
    setUser(state, val) {
      state.profile = val
    },
    setError(state, val) {
      let new_error = {}
      let orig_errors = state.errors
      new_error[val.field] = val.text
      orig_errors.push(new_error)
      state.errors = orig_errors
    },
    setUnits(state, val) {
      state.units = val
    },
    setForces(state, val) {
      state.forces = val
    },
    selectUnit(state,val) {
      state.current.unit = val
    },
    selectForce(state,val) {
      state.current.force = val
    },
    deleteUnit(state,val) {
      console.log(`Removed unit ${val}`)
    },
    deleteForce(state,val) {
      console.log(`Removed force ${val}`)
    }

  },
  getters: {
    errors(state) {
      return state.errors
    }
  },
  actions: {
    async signup({ dispatch }, form) {
      // sign user up
      try {
        const { user } = await auth.createUserWithEmailAndPassword(form.email, form.password)
        var nameParts = form.name.split(' ')
        var firstName = nameParts[0];
        var lastName = nameParts.slice(1).join(" ");
        // create user profile object in userCollections
        await db.collection('users').doc(user.uid).set({
          name: {
            first: firstName,
            last: lastName,
            title: form.title
          },
          email: form.email,
        })
        dispatch('fetchUser', user)
        router.push('/')
      } catch (err) {
        console.log('Error',err)
        if(err.code == 'auth/invalid-email') { dispatch('setMessage',{type: 'error', field: 'email', text: err.message})}
        if(err.code == 'auth/email-already-in-use') { dispatch('setMessage',{type: 'error', field: 'email', text: err.message})}
        if(err.code == 'auth/weak-password') { dispatch('setMessage',{type: 'error', field: 'password', text: err.message})}
      }
    },
    setMessage({commit},messageObj) {
      let text = messageObj.text
      let field = messageObj.field || false
      let type = messageObj.type
      if(type=='error' && field) { commit('setError',{text: text, field: field}) }
      else if(type=='error' && !field ) { commit('setError',{text: text, field: 'global'}) }
    },
    async login({ dispatch }, form) {
      const { user } = await auth.signInWithEmailAndPassword(form.email, form.password)
      dispatch('fetchUser', user)
    },
    async logout({ commit }) {
      await auth.signOut()
      commit('setUser', {})
      router.push('/login')
    },
    async fetchUser({ commit,dispatch }, login) {
      const user = await db.collection('users').doc(login.uid).get()
      let profile = {
        ...user.data(),
        uid: login.uid
      }
      commit('setUser', profile)

      dispatch('fetchUnits')
      dispatch('fetchForces')
      
      if (router.currentRoute.path === '/login') { router.push('/') }
    },
    async fetchUnits({ state , commit }) {
      await db.collection(`users/${state.profile.uid}/units`).onSnapshot((snapshot) => {
        let unitsArray = []
        snapshot.forEach(doc => {
          let unit = doc.data()
          unit.uid = doc.id
          unitsArray.push(unit)
        })
        commit('setUnits', unitsArray)
      })
    },
    async fetchForces({ state , commit }) {
      await db.collection(`users/${state.profile.uid}/forces`).onSnapshot((snapshot) => {
        let forcesArray = []
        snapshot.forEach(doc => {
          let force = doc.data()
          force.uid = doc.id
          forcesArray.push(force)
        })
        commit('setForces', forcesArray)
      })
    },
    async fetchUnit({state,commit}, unit_id) {
      commit('selectUnit',unit_id)
      let unit_path = `users/${state.profile.uid}/units`
      let unit = await db.collection(unit_path).doc(unit_id).get()
      return unit
    },
    async duplicateUnit({state},orig_unit_id){
      let unit_path = `users/${state.profile.uid}/units`
      let orig_unit = await db.collection(unit_path).doc(orig_unit_id).get()
      orig_unit = orig_unit.data()
      orig_unit.name = orig_unit.name + " Copy"
      orig_unit.psychic_powers_locked = false
      orig_unit.equipment_locked = false
      orig_unit.size_locked = false
      orig_unit.relics_locked = false
      orig_unit.force_id = null
      orig_unit.battle_scars = []
      orig_unit.battle_totals = { fought: 0, survived: 0, }
      orig_unit.combat_totals = { any: 0, melee: 0, psychic: 0, ranged: 0, }
      orig_unit.crusade_pts = 0
      orig_unit.experience_pts = 0
      orig_unit.honours = []
      orig_unit.rank = 'battle-ready'
      let new_unit_id = await db.collection(unit_path).add(orig_unit)
      console.log('New unit ID',new_unit_id)
    },
    async saveUnit({ state },unit) {
      let docRef = null
      let collectionRef = db.collection(`users/${state.profile.uid}/units`)
      // Lock down after during save
      unit.psychic_powers_locked = true 
      unit.warlord_traits_locked = true
      unit.equipment_locked = true
      unit.size_locked = true 
      unit.relics_locked = true
      if(unit.uid) { 
        let tmpUnit = {...unit}; delete tmpUnit.uid
        docRef = await collectionRef.doc(unit.uid).set(tmpUnit,{ merge: true }) 
      }
      else { docRef = await collectionRef.add(unit) }
      console.log("Document written with ID: ", docRef ? docRef.id : unit.uid );
    },
    async deleteUnit({ state, commit},unit_id) {
      let collectionRef = db.collection(`users/${state.profile.uid}/units`)
      await collectionRef.doc(unit_id).delete()
      commit('deleteUnit',unit_id)
    },
    async fetchForce({state,commit}, force_id) {
      commit('selectForce',force_id)
      let force_path = `users/${state.profile.uid}/forces`
      let force = await db.collection(force_path).doc(force_id).get()
      return force
    },
    async saveForce({ state },force) {
      let docRef = null
      let collectionRef = db.collection(`users/${state.profile.uid}/forces`)
      if(force.force_id) { docRef = await collectionRef.doc(force.force_id).set(force,{ merge: true }) }
      else { docRef = await collectionRef.add(force) }
      console.log("Document written with ID: ", docRef ? docRef.id : force.force_id );
    },
    async deleteForce({ state, commit},force_id) {
      let collectionRef = db.collection(`users/${state.profile.uid}/forces`)
      let unitsref = db.collection(`users/${state.profile.uid}/units`) 
      let batch = db.batch()
      batch.delete(collectionRef.doc(force_id))
      state.units.forEach((unit) => { 
        if(unit.force_id == force_id) { 
          batch.update(unitsref.doc(unit.uid),{force_id: null}) 
        }
      })
      batch.commit()
      commit('deleteForce',force_id)
    },
    async lockForce({state},force){
      let forceRef = db.collection(`users/${state.profile.uid}/forces`).doc(force.uid)
      await forceRef.set({locked: true },{merge: true})
    },
    async addUnitToForce({state},pairing) {
      console.log("pairing",pairing)
      let unitRef = db.collection(`users/${state.profile.uid}/units`).doc(pairing.unit_id)
      let forceRef = db.collection(`users/${state.profile.uid}/forces`).doc(pairing.force_id)
      let force_doc = await forceRef.get()
      let force = force_doc.data()
      let units = force.units || []
      units.push(pairing.unit_id)
      // let power = units.reduce((total,unit)=> total + unit.power_rating)
      let power = force.supplies.used ? force.supplies.used + pairing.unit_power : pairing.unit_power
      await forceRef.set({supplies: { used: power }, units: units},{merge: true})
      await unitRef.set({force_id: pairing.force_id},{merge: true})
    },
    async removeUnitFromForce({state,dispatch},pairing) {
      console.log("unpairing",pairing)
      let unitRef = db.collection(`users/${state.profile.uid}/units`).doc(pairing.unit_id)
      let forceRef = db.collection(`users/${state.profile.uid}/forces`).doc(pairing.force_id)
      let force_doc = await forceRef.get()
      let force = force_doc.data()
      let units = force.units || []
      units = units.filter((elm) => { elm != pairing.unit_id})
      let power = Math.max(0,force.supplies.used - pairing.unit_power)
      let batch = db.batch()
      batch.set(forceRef,{supplies: { used: power }, units: units},{merge: true})
      batch.set(unitRef,{force_id: null},{merge: true})
      batch.commit()
      dispatch('resetUnit',pairing.unit_id)
    },
    async resetUnit({state},unit_id) {
      let unitRef = db.collection(`users/${state.profile.uid}/units`).doc(unit_id)
      let blank_slate = { 
        battle_scars: [],
        battle_totals: { fought: 0, survived:0,},
        combat_totals: { any: 0, melee: 0, psychic: 0, ranged: 0, },
        crusade_pts: 0,
        experience_pts: 0,
        honours: [],
        rank: 'battle-ready',
        relics: null, 
        warlord_traits: null,
        equipment_locked: false, 
        psychic_powers_locked: false,
        size_locked: false,
        warlord_traits_locked: false,
      }
      await unitRef.set(blank_slate,{merge:true})
    },


    //  Requestion Pts Spend

    async increaseSupply({state,dispatch},force) {
      if (force.requisition_pts < 1) { dispatch('setMessage',{ type: 'error', field: null, text: 'Cannot spend what you don\'t have' }) }
      else { 
        let batch = db.batch();
        let forceRef = db.collection(`users/${state.profile.uid}/forces`).doc(force.uid)
        let newHistoryRef = forceRef.collection('history').doc();
        force.supplies.limit += 5
        force.requisition_pts -= 1
        batch.set(forceRef,force,{merge: true})
        batch.set(newHistoryRef,{action: 'spend-requisition', details:'Increased Supply', log_time: firebaseTimeNow()})
        await batch.commit()
      }
    },
    async freshRecruits({state},unit) {
      let batch = db.batch();
      let unitRef = db.collection(`users/${state.profile.uid}/units`).doc(unit.uid)
      let forceRef = db.collection(`users/${state.profile.uid}/forces`).doc(unit.force_id)
      let newHistoryRef = forceRef.collection('history').doc();
      batch.set(unitRef,{size_locked: false},{merge: true})
      batch.set(forceRef,{requisition_pts: decrement},{merge: true})
      batch.set(newHistoryRef,{action: 'spend-requisition', details:'recruit Units', current_value: unit.size, log_time: firebaseTimeNow()})
      await batch.commit()
      router.push({name: 'unit.edit', params: { unit_id: unit.uid } , query: { start_field: 'size'}})
    },
    async rearmUnit({state},unit) {
      let batch = db.batch();
      let unitRef = db.collection(`users/${state.profile.uid}/units`).doc(unit.uid)
      let forceRef = db.collection(`users/${state.profile.uid}/forces`).doc(unit.force_id)
      let newHistoryRef = forceRef.collection('history').doc();
      batch.set(unitRef,{equipment_locked: false},{merge: true})
      batch.set(forceRef,{requisition_pts: decrement},{merge: true})
      batch.set(newHistoryRef,{action: 'spend-requisition', details:'rearm Unit', current_value: unit.equipment, log_time: firebaseTimeNow()})
      await batch.commit()
      router.push({name: 'unit.edit', params: { unit_id: unit.uid }, query: { start_field: 'equipment' } })
    },
    async repairUnit({state},data) {
      console.log('pre',data.unit.battle_scars)
      console.log('Removing index ',data.scar_index)
      data.unit.battle_scars.splice(data.scar_index,1)
      console.log('post',data.unit.battle_scars)
      let batch = db.batch();
      let unitRef = db.collection(`users/${state.profile.uid}/units`).doc(data.unit.uid)
      let forceRef = db.collection(`users/${state.profile.uid}/forces`).doc(data.unit.force_id)
      let newHistoryRef = forceRef.collection('history').doc()
      batch.set(unitRef,{battle_scars: data.unit.battle_scars},{merge: true})
      batch.set(forceRef,{requisition_pts: decrement},{merge: true})
      batch.set(newHistoryRef,{action: 'spend-requisition', details:'repair Unit', current_value: data.unit.battle_scars, log_time: firebaseTimeNow()})
      await batch.commit()
      // router.push({name: 'unit.listing', params: { unit_id: data.unit.uid }, query: { start_field: null } })
    },
    async psychicMeditation({state},unit) {
      let batch = db.batch();
      let unitRef = db.collection(`users/${state.profile.uid}/units`).doc(unit.uid)
      let forceRef = db.collection(`users/${state.profile.uid}/forces`).doc(unit.force_id)
      let newHistoryRef = forceRef.collection('history').doc();
      batch.set(unitRef,{crusade_pts: increment,psychic_powers_locked: false},{merge: true})
      batch.set(forceRef,{requisition_pts: decrement},{merge: true})
      batch.set(newHistoryRef,{action: 'spend-requisition', details:'psychic meditation', current_value: unit.psychic_powers, log_time: firebaseTimeNow()})
      await batch.commit()
      router.push({name: 'unit.edit', params: { unit_id: unit.uid }, query: { start_field: 'psychic_powers' } })
    },
    async gainWarlordTrait({state},unit) {
      let batch = db.batch();
      let unitRef = db.collection(`users/${state.profile.uid}/units`).doc(unit.uid)
      let forceRef = db.collection(`users/${state.profile.uid}/forces`).doc(unit.force_id)
      let newHistoryRef = forceRef.collection('history').doc();
      batch.set(unitRef,{crusade_pts: increment, warlord_traits_locked: false},{merge: true})
      batch.set(forceRef,{requisition_pts: decrement},{merge: true})
      batch.set(newHistoryRef,{action: 'spend-requisition', details:'warlord traits', current_value: unit.warlord_traits || '', log_time: firebaseTimeNow()})
      await batch.commit()
      // router.push({name: 'unit.edit', params: { unit_id: unit.uid }, query: { start_field: 'warlord_traits' } })
    },
    async gainRelic({state},unit) {
      let batch = db.batch();
      let unitRef = db.collection(`users/${state.profile.uid}/units`).doc(unit.uid)
      let forceRef = db.collection(`users/${state.profile.uid}/forces`).doc(unit.force_id)
      let newHistoryRef = forceRef.collection('history').doc();
      batch.set(unitRef,{crusade_pts: increment, relics_locked: false},{merge: true})
      batch.set(forceRef,{requisition_pts: decrement},{merge: true})
      batch.set(newHistoryRef,{action: 'spend-requisition', details:'gain a relic', current_value: unit.relics || '', log_time: firebaseTimeNow()})
      await batch.commit()
      router.push({name: 'unit.edit', params: { unit_id: unit.uid }, query: { start_field: 'relics' } })
    },

    // Battle related updatage 

    startBattle({state},force_id) {
      let forceRef = db.collection(`users/${state.profile.uid}/forces`).doc(force_id)
      let newBattleRef = forceRef.collection('battles').doc();
      router.push({name: 'battle.workflow', params: { force_id: force_id, battle_id: newBattleRef.id } })
    },
    async saveBattleDraft({state},battle) {
      console.log('Saving',state.profile.uid,battle)
      let forceRef = db.collection(`users/${state.profile.uid}/forces`).doc(battle.force_id)
      let currentBattleRef = forceRef.collection('battles').doc(battle.battle_id)
      currentBattleRef.set({ locked: false, units: battle.units },{merge: true}).catch((error) => { 
        console.log('Error on save:',error,battle.units)
      })
    },
    async loadBattleDraft({state},battle){
      // console.log('Load form URL:',`users/${state.profile.uid}/forces/${battle.force_id}/battles`)
      let battleRef = db.collection(`users/${state.profile.uid}/forces/${battle.force_id}/battles`).doc(battle.battle_id)
      let battleData = await battleRef.get()
      return await battleData.data()
    },
    async updateForceWithBattle({state},battle) {
      console.log("Commiting Battle Update:", battle, forceRef)
      
      let force = {  battle_totals: { total: increment } }
      if(battle.result == 'win') { force.battle_totals.won = increment }
      if(battle.result == 'lose') { force.battle_totals.lost = increment }
      
      let forceRef = db.collection(`users/${state.profile.uid}/forces`).doc(battle.force_id)
      let battleRef = forceRef.collection('battles').doc(battle.uid)
      let unitsRef = db.collection(`users/${state.profile.uid}/units`)

      let batch = db.batch()
      batch.set(battleRef,{locked: true},{merge:true})
      batch.set(forceRef, force, {merge: true})
      battle.units.forEach( (unit) => {
        batch.set(unitsRef.doc(unit.uid),unit)
      })
      await batch.commit()
    },
  },
  modules: {
  }
})

